import React, { useCallback, useEffect } from "react";

import { Message } from "semantic-ui-react";
import { useMessageById } from "../../store/selectors/messageSelector";
import { createHideMessageAction } from "../../store/actions/messageActions";
import { useDispatch } from "react-redux";

interface IAppMessageProps {
    messageId: string;
}

const AppMessage: React.FC<IAppMessageProps> = ({ messageId }) => {
    const dispatch = useDispatch();
    const message = useMessageById(messageId);

    const handleDismiss = useCallback(() => {
        dispatch(createHideMessageAction(messageId))
    }, [dispatch, messageId]);


    useEffect(() => {
        return () => { handleDismiss() }
    }, [handleDismiss])

    if (!message) {
        console.log("This message dosn't exsits");
        return null;
    }

    return <Message {...message} onDismiss={handleDismiss} />

};


export default AppMessage;
